import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { plainToClass } from 'class-transformer';
// Rxjs import
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// Constant imports
import { URLConstants } from '../../../_constants/url-constants';
import { CacheDuration } from '../../../_constants/cache-duration';
// Model imports
import { EntitySelectorResultDto } from '../../shared-cirabooks-module/_models/common/enity-selector-result-dto';
// Service imports
import { MPCacheRegistrationService } from '../../../_services/shared-services/mp-cache-registration-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../_services/shared-services/mp-cache-registration-service";
export class EntityService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    loadEntities() {
        return new Observable((observer) => {
            this.getEntities().subscribe((entities) => {
                // Save in dictionary
                EntityService.entitiesMap = new Map();
                entities.forEach((rec) => EntityService.entitiesMap.set(rec.entityId, rec));
                observer.next();
                observer.complete();
            }, () => {
                observer.next();
                observer.complete();
            });
        });
    }
    getEntities() {
        const url = `${URLConstants.ccCommunityCBBaseUrl}/entities`;
        this.cacheRegistrationService.registerForCache(url);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        // Call endpoint
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(EntitySelectorResultDto, response)));
    }
}
EntityService.entitiesMap = new Map();
EntityService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EntityService_Factory() { return new EntityService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: EntityService, providedIn: "root" });
